import { Banner } from "@circleco/compass/components/Banner";

import { t } from "@/i18n-js/instance";
import { useOpenCircleAi } from "@/react/components/CircleAi/useOpenCircleAi";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";

const localeRoot = "trial_banner.circle_ai_marketing_campaign";

export const CircleAIMarketingCampaignBanner = () => {
  const { openNewChat } = useOpenCircleAi();
  const { trackEvent } = useEventsTracker();

  const handleOnClick = () => {
    trackEvent("trial_banner.circle_ai_campaign.cta_clicked", {});
    openNewChat();
  };

  return (
    <Banner
      variant="info"
      title={t(`${localeRoot}.title`)}
      actionProps={{
        variant: "outline",
        children: t(`${localeRoot}.cta`),
        onClick: handleOnClick,
      }}
    />
  );
};
